export default __webpack_public_path__ + "static/media/home-search-food.e90789a0.jpg";